export function zodCreateInputOmit() {
    return {
        id: true,
        createdAt: true,
        updatedAt: true,
    };
}
export function zodUpdateInputOmit() {
    return {
        id: true,
        createdAt: true,
        updatedAt: true,
        persistentId: true,
    };
}
